import { gql } from "@apollo/client";

export const GENERATE_CREDIT_NOTE_PDF = gql`
  mutation generateCreditNotePdf($id: ID!) {
    generateCreditNotePdf(id: $id){
        creditNoteUrl
    }
  }
`;